import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { withRouter } from 'react-router-dom';
import RouterLink from '../RouterLink';
import {
  Checkbox,
  Flex,
} from '..';
import withContext from '../WithContext';
import { Consumer } from './Context';

const propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  shortcutActions: PropTypes.node,
  url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  context: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    selectedItems: PropTypes.array,
    onSelectionChange: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    promotedBulkActions: PropTypes.array,
  }).isRequired,
};

const defaultProps = {
  shortcutActions: null,
};

const ItemLi = styled.li`
  cursor: pointer;
  z-index: 1;
  + li {
    border-top: .1rem solid ${props => props.theme.borderColor};
  }
`;

const ItemWrapper = styled.div`
  display: flex;
  position: relative;
  &:hover {
    background-color: ${props => props.theme.backgroundColor_hover};
  }
  &:focus-within {
    background-color: ${props => props.theme.backgroundColor_hover};
    border-left: 3px solid ${props => props.theme.borderColor_theme_focus}
  }
`;

// Invisible link for keyboard support and screen readers
const ItemLink = styled(RouterLink)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  z-index: 1;
`;

const ItemContent = styled.div`
  padding: 1em;
  width: 100%;
`;

const ShortcutActionsWrapper = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  visibility: hidden;
  ${ItemLi}:hover & {
    visibility: visible;
  }
  ${ItemLi}:focus-within & {
    visibility: visible;
  }
`;

const ItemActions = styled.div`
  margin: auto;
  padding-left: ${props => props.theme.space_inline_md};
  z-index: 2;
`;


/*
 * Note: Shortcut actions are not visible on mobile, so they must
 * be accessible by some other method. (Also, they are not keyboard
 * accessible in Microsoft browsers since focus-within is not supported)
 */
class ResourceListItem extends Component {
  isSelected = () => {
    const {
      id,
      context: { selectedItems },
    } = this.props;
    return (
      selectedItems && selectedItems.includes(id)
    );
  }

  handleSelection = ({ target: { checked } }) => {
    const {
      id,
      context: { onSelectionChange },
    } = this.props;
    onSelectionChange(checked, id);
  }

  render() {
    const {
      children, shortcutActions, url, context, id,
    } = this.props;
    const {
      promotedBulkActions,
    } = context;
    let childrenWithShortcuts = children;
    let checkBoxMarkup;
    if (promotedBulkActions && promotedBulkActions.length > 0) {
      checkBoxMarkup = (
        <ItemActions>
          <Checkbox
            label={`Select plan ${id} for compare`}
            hideLabel
            id={id}
            checked={this.isSelected()}
            onChange={this.handleSelection}
          />
        </ItemActions>
      );
    }
    if (shortcutActions) {
      childrenWithShortcuts = (
        <Flex>
          <Flex.Item>
            {children}
          </Flex.Item>
          <Flex.Item marginStart="auto" onClick={event => event.stopPropagation()}>
            <ShortcutActionsWrapper>
              {shortcutActions}
            </ShortcutActionsWrapper>
          </Flex.Item>
        </Flex>
      );
    }

    /* Give the ItemLi tabIndex="0" if/when we support bulk actions to select it,
     * rather than follow the url
     * Also, we may need to add onFocus/onBlur to support shortcut action accessibility on IE
     */
    return (
      <ItemLi>
        <ItemWrapper>
          <ItemLink href={url} />
          {checkBoxMarkup}
          <ItemContent>
            {childrenWithShortcuts}
          </ItemContent>
        </ItemWrapper>
      </ItemLi>
    );
  }
}


ResourceListItem.propTypes = propTypes;
ResourceListItem.defaultProps = defaultProps;
export default withRouter(withContext(Consumer)(ResourceListItem));
